import React from "react";
import { Link } from "react-router-dom";

// Renders the TGI wordmark in CSS so we get full colour control:
// - on light backgrounds: black "Talk" + green "Golf"
// - on dark backgrounds:  white "Talk" + green "Golf"
const sizeMap = {
  sm: { wordmark: "text-[18px]", micro: "text-[7px]", fundLabel: "text-[9px]", fundWord: "text-[11px]" },
  md: { wordmark: "text-[24px] md:text-[26px]", micro: "text-[8px] md:text-[9px]", fundLabel: "text-[9px] md:text-[10px]", fundWord: "text-[13px] md:text-[14px]" },
  lg: { wordmark: "text-[40px]", micro: "text-[11px]", fundLabel: "text-[11px]", fundWord: "text-[17px]" },
  xl: { wordmark: "text-[64px]", micro: "text-[14px]", fundLabel: "text-[13px]", fundWord: "text-[21px]" },
};

export default function Wordmark({ size = "md", withFund = true, dark = false }) {
  const s = sizeMap[size] || sizeMap.md;
  const talkColor = dark ? "text-background" : "text-foreground";
  const microColor = dark ? "text-background/70" : "text-foreground/55";
  const fundLabelColor = dark ? "text-background/70" : "text-foreground/70";
  const fundAccent = dark ? "text-secondary" : "text-primary";
  const divider = dark ? "border-background/25" : "border-foreground/20";

  return (
    <Link to="/" className="inline-flex items-end gap-3 group" data-testid="brand-wordmark">
      <div className="leading-none">
        <div className={`tgi-wordmark ${s.wordmark} leading-[0.85]`}>
          <span className={talkColor}>Talk</span>
          <span className="text-primary ml-[0.15em]">Golf</span>
        </div>
        <div
          className={`mt-1 ${s.micro} tracking-[0.3em] ${microColor} uppercase`}
          style={{ fontFamily: "Manrope, sans-serif", fontWeight: 500 }}
        >
          International
        </div>
      </div>
      {withFund && (
        <span
          className={`uppercase tracking-[0.22em] ${s.fundLabel} leading-tight pl-3 border-l ${divider} ${fundLabelColor} self-stretch flex flex-col justify-center`}
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          <span>Golfer</span>
          <span className={`${fundAccent} ${s.fundWord} font-semibold normal-case tracking-tight`} style={{ fontFamily: "Manrope, sans-serif" }}>
            Fund
          </span>
        </span>
      )}
    </Link>
  );
}
